import script from "./PersonalInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&setup=true&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=4982a30a&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4982a30a"]])

export default __exports__